import { render, staticRenderFns } from "./ECButton.vue?vue&type=template&id=21e3244e&scoped=true&"
import script from "./ECButton.vue?vue&type=script&lang=js&"
export * from "./ECButton.vue?vue&type=script&lang=js&"
import style0 from "./ECButton.vue?vue&type=style&index=0&id=21e3244e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e3244e",
  null
  
)

export default component.exports